export default "__VITE_ASSET__548ebcf4__"